import type { MapPin } from '@zoocasa/go-search';
import type { DisplayablePin } from 'domain/map-pin/map-pin.types';

/**
 * Assigns a display mode to each pin based on listing count, sort rank,
 * and the viewport-derived fullPinThreshold.
 *
 * All pins (buildings and standalone) share a single pool:
 * - Pins within the threshold: 'building' if listingCount > 1, else 'full'.
 * - Pins beyond the threshold: 'dot' regardless of listing count.
 */
export function assignPinDisplayModes(
  pins: MapPin[] | undefined,
  fullPinThreshold: number,
): DisplayablePin[] {
  if (!pins?.length) return [];

  const allFull = pins.length <= fullPinThreshold;

  return pins.map((pin, index) => {
    let displayMode: DisplayablePin['displayMode'];

    if (allFull || index < fullPinThreshold) {
      displayMode = pin.listingCount > 1 ? 'building' : 'full';
    } else {
      displayMode = 'dot';
    }

    return { pin, displayMode, sortRank: index };
  });
}
